import { Reveal } from "./Reveal";
import { RuotaMark } from "./RuotaMark";

export const About = () => (
  <section
    id="about"
    data-testid="about-section"
    className="border-t border-[rgba(22,138,145,0.15)] bg-[#F7F0E3] py-24 sm:py-32"
  >
    <div className="mx-auto max-w-7xl px-6 sm:px-10 lg:px-16">
      <div className="grid items-center gap-12 md:grid-cols-12 lg:gap-20">
        <div className="md:col-span-5">
          <Reveal>
            <div className="relative mx-auto max-w-sm">
              <div className="overflow-hidden rounded-t-[10rem] rounded-b-3xl">
                <img
                  src="/jill.jpg"
                  alt="Jill Bauman, founder of Ruota Travel, at the Acropolis"
                  loading="lazy"
                  data-testid="about-portrait"
                  className="h-[440px] w-full object-cover transition-transform duration-[1.6s] ease-out hover:scale-105"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 hidden sm:block">
                <RuotaMark size={72} duration={20} />
              </div>
            </div>
          </Reveal>
        </div>

        <div className="md:col-span-7">
          <Reveal delay={0.1}>
            <p className="font-accent text-xs font-bold uppercase tracking-[0.25em] text-[#E2725B]">
              About Me · The Person Behind the Wheel
            </p>
            <h2
              data-testid="about-heading"
              className="mt-5 max-w-xl font-display text-3xl font-light leading-tight tracking-tight text-[#0D1F23] sm:text-5xl"
            >
              Ciao, I'm <span className="italic text-[#E2725B]">Jill</span>.
            </h2>
            <p className="mt-3 font-display text-xl italic text-[#4A5557]">
              (Why "ciao"? I'm a lifelong learner currently deep into Italian. It slips into
              everything, and honestly, I'm not sorry about it.)
            </p>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-[#4A5557] sm:text-lg">
              I've spent my career on every side of a great journey: luxury hospitality and
              high-touch guest experiences, a multi-million-dollar wellness club in Manhattan,
              transformative travel at Canyon Ranch, and most recently representing some of the
              world's most exclusive hotels and destination experts. Ruota is where all of it
              comes together.
            </p>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-[#4A5557] sm:text-lg">
              Based between New York City and the Berkshires, I bring decades of industry
              relationships and personal attention to every journey. When you write to Ruota,
              it lands with me and I can't wait to hear where you're dreaming of.
            </p>
            <p className="mt-8 font-display text-2xl italic text-[#168A91]">
              Jill
            </p>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
